module.exports = __webpack_public_path__ + "img/teach.b6e25a1d.png";